import { render, staticRenderFns } from "./dict.vue?vue&type=template&id=1e99cf1e&scoped=true&"
import script from "./dict.vue?vue&type=script&lang=ts&"
export * from "./dict.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e99cf1e",
  null
  
)

export default component.exports